import { render, staticRenderFns } from "./device.vue?vue&type=template&id=50973a20&scoped=true&"
import script from "./device.vue?vue&type=script&lang=js&"
export * from "./device.vue?vue&type=script&lang=js&"
import style0 from "./device.vue?vue&type=style&index=0&id=50973a20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50973a20",
  null
  
)

component.options.__file = "device.vue"
export default component.exports